import type { RegisteredServices } from '@/core/container/types'
import type { TmWrappers } from '@/wrappers'
import type { SmsSurveyNodeType } from '@/data/models/domain/services/smsSurveys/types'
import type { TmCountryCode, PhoneType } from '@/services/types'
import type SenderSource from '@/data/models/domain/SenderSource'
import type { ByocNumbersResponse } from '@/services/domain/byoc/types'
import type { SmsSurveyRecipientCountryAvailableNumber } from '@/data/models/domain/services/smsSurveys/SmsSurveyRecipientCountry'
import type { ByocProvider } from '@/data/models/domain/services/byoc/types'

export const smsSurveysModalId: TmWrappers = 'smsSurveys'
export const smsSurveysTable = 'smsSurveysTable' as RegisteredServices

export type SmsSurveyRecipientCountrySender = {
  id: string
  type: PhoneType
  phone: string
}

export type SmsSurveyDetailsPayload = {
  name: string
  lists: string[]
  filteredViews: string[]
  folders: string[]
  contacts: string[]
  phones: string[]
  senders: Partial<Record<TmCountryCode, Omit<SmsSurveyRecipientCountrySender, 'phone'>>>
}

export type SmsSurveyNodePutBody = {
  id: string
  label?: string
  body?: string
  sendDelay?: number
  isEndNode?: boolean
}

export type SmsSurveyNodePostBody = {
  nodeType: SmsSurveyNodeType
  label?: string
  body: string
  startNode: string
  sendDelay?: number
}

export type SmsSurveyDetailsCountries = {
  allowDedicated: boolean
  countryId: TmCountryCode
  fromNumber: string | null
  id: number | null
  // eslint-disable-next-line @typescript-eslint/naming-convention
  users_carrier_phone_id: number | null
  // eslint-disable-next-line @typescript-eslint/naming-convention
  users_inbound_id: number | null
}

interface SmsSurveyRecipientCountryResponseCountry {
  countryId: TmCountryCode
  buyable: boolean
  availableNumbers: SmsSurveyRecipientCountryAvailableNumber[]
}

export type SmsSurveyRecipientCountryResponse = {
  dedicated: SmsSurveyRecipientCountryResponseCountry[]
} & Record<keyof ByocNumbersResponse, SenderSource[]>

export interface SmsSurveyRecipientCountryMappedResponse {
  id: TmCountryCode
  countryId: TmCountryCode
  buyable: boolean
  availableNumbers: SmsSurveyRecipientCountryAvailableNumber[]
  byoc: Record<ByocProvider, SenderSource[]>
  sender: SmsSurveyRecipientCountrySender | null
}
